import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=bcee493a&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcee493a')) {
      api.createRecord('bcee493a', component.options)
    } else {
      api.reload('bcee493a', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=bcee493a&", function () {
      api.rerender('bcee493a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Auth/Pages/ResetPassword.vue"
export default component.exports